module.exports = __webpack_public_path__ + "static/img/step2.54cda389.png";